// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9741a2e2","568":"ef4ab70d"}[chunkId] + ".chunk.js";
};